import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

export default function TaxationCompliance() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab =
    location.pathname === "/direct-tax"
      ? "direct"
      : location.pathname === "/indirect-tax"
      ? "indirect"
      : "taxation";

  const handleTabClick = (path) => navigate(path);

  return (
    <>
      <Header />

      {/* ===== HERO SECTION ===== */}
      <section
        className="about-hero"
        style={{ backgroundImage: "url('/assets/img/tax.jpg')" }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>Taxation & Compliance</h1>
          <p>
            Comprehensive tax advisory and compliance solutions for individuals
            and businesses.
          </p>
        </div>
      </section>

      {/* ===== TABS ===== */}
      <div className="tax-tabs">
        <button
          className={activeTab === "taxation" ? "active" : ""}
          onClick={() => handleTabClick("/taxation-compliance")}
        >
          Taxation & Compliance
        </button>
        <button
          className={activeTab === "direct" ? "active" : ""}
          onClick={() => handleTabClick("/direct-tax")}
        >
          Direct Tax (Income Tax)
        </button>
        <button
          className={activeTab === "indirect" ? "active" : ""}
          onClick={() => handleTabClick("/indirect-tax")}
        >
          Indirect Tax (GST)
        </button>
      </div>

      {/* ===== PREMIUM PROFESSIONAL CONTENT (Option A) ===== */}
      <section className="tp-section tp-intro">
        <div className="tp-container">
          <div className="tp-intro-grid">
            <div className="tp-intro-left">
              <span className="tp-kicker">Taxation & Compliance Services</span>
              <h2 className="tp-h2">
                Comprehensive & Reliable Tax Management for Sustainable
                Financial Growth
              </h2>

              <p className="tp-lead">
                Managing taxation in today’s regulatory environment has become
                increasingly complex. With frequent amendments to tax laws,
                evolving compliance requirements, and stricter monitoring by tax
                authorities, businesses and individuals need expert guidance to
                stay compliant and financially efficient.
              </p>

              <p className="tp-text">
                Our Taxation & Compliance Services provide a complete framework
                to help you manage your tax responsibilities accurately,
                strategically and on time, ensuring you operate with confidence
                and peace of mind.
              </p>

              <p className="tp-text">
                We understand that every taxpayer — whether an individual, a
                startup, a partnership firm, an SME or a corporate entity — has
                unique financial structures, challenges and objectives. That’s
                why we offer customized solutions that combine deep domain
                expertise, advanced compliance systems and practical advisory
                support to optimize your tax outcomes.
              </p>
            </div>

            <aside className="tp-intro-right">
              <div className="tp-box">
                <h4 className="tp-box-title">Our Promise</h4>
                <p className="tp-box-text">
                  We simplify complex tax procedures, minimize risks, and
                  empower you to make smarter financial decisions. From planning
                  and documentation to assessments, representation and dispute
                  resolution — professional and transparent.
                </p>
                <ul className="tp-quicklist">
                  <li>Accurate filings & record keeping</li>
                  <li>Proactive compliance monitoring</li>
                  <li>Expert audit & scrutiny handling</li>
                </ul>
                <div className="tp-box-cta">
                  <Link
                    to="/contactus"
                    className="tp-btn apply-btn"
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                  >
                    Contact Us
                  </Link>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <section className="tp-section tp-offer">
        <div className="tp-container">
          <h3 className="tp-section-title">
            {" "}
            What We Offer Under Taxation & Compliance
          </h3>

          <div className="tp-cards">
            <article className="tp-card">
              <div className="tp-card-icon" aria-hidden>
                ✔
              </div>
              <div className="tp-card-body">
                <h4>Advisory & strategic tax planning</h4>
                <p>
                  Detailed planning and structuring to reduce tax burden and
                  align with business goals.
                </p>
              </div>
            </article>

            <article className="tp-card">
              <div className="tp-card-icon" aria-hidden>
                ✔
              </div>
              <div className="tp-card-body">
                <h4>Comprehensive return filing & documentation support</h4>
                <p>
                  Timely, accurate preparation and filing for individuals,
                  firms, and companies.
                </p>
              </div>
            </article>

            <article className="tp-card">
              <div className="tp-card-icon" aria-hidden>
                ✔
              </div>
              <div className="tp-card-body">
                <h4>Regular compliance monitoring & reporting</h4>
                <p>
                  Automated reminders, dashboards and regular reviews to stay
                  ahead of deadlines.
                </p>
              </div>
            </article>

            <article className="tp-card">
              <div className="tp-card-icon" aria-hidden>
                ✔
              </div>
              <div className="tp-card-body">
                <h4>Audit support and scrutiny representation</h4>
                <p>
                  Hands-on representation and documentation during assessments
                  and audits.
                </p>
              </div>
            </article>

            <article className="tp-card">
              <div className="tp-card-icon" aria-hidden>
                ✔
              </div>
              <div className="tp-card-body">
                <h4>Risk management & compliance health checks</h4>
                <p>
                  Periodic health checks to identify risk areas and remedial
                  action plans.
                </p>
              </div>
            </article>

            <article className="tp-card">
              <div className="tp-card-icon" aria-hidden>
                ✔
              </div>
              <div className="tp-card-body">
                <h4>Resolution of notices, queries & legal challenges</h4>
                <p>
                  Efficient handling of notices and disputes with clear
                  documentation and representation.
                </p>
              </div>
            </article>
          </div>

          <p className="tp-text center mt-4">
            We work as your extended finance partner — enabling you to optimize
            tax efficiency, control costs, and focus on growth instead of
            administrative responsibilities.
          </p>
        </div>
      </section>

      {/* <section className="tp-section tp-approach">
  <div className="tp-container">
    <h3 className="tp-section-title"> Our Approach to Tax Management</h3>

    <div className="tp-approach-wrap">
      <ol className="tp-approach-list">
        <li><strong>Understanding:</strong> Understand your financial operations and tax exposure.</li>
        <li><strong>Identifying:</strong> Identify planning opportunities and compliance risks.</li>
        <li><strong>Implementing:</strong> Implement accurate tax processes and automation.</li>
        <li><strong>Representing:</strong> Provide expert representation in regulatory interactions.</li>
        <li><strong>Monitoring:</strong> Continually monitor changes in tax legislation.</li>
      </ol>

      <div className="tp-approach-note">
        <p>
          This structured process ensures long-term tax savings, reduced financial uncertainty and a robust compliance framework aligned with your goals.
        </p>
      </div>
    </div>
  </div>
</section> */}

      <section className="tp-section tp-benefits">
        <div className="tp-container">
          <h3 className="tp-section-title"> Benefits of Partnering With Us</h3>

          <div className="tp-benefit-grid">
            <div className="tp-benefit">
              <h4>End-to-end tax compliance</h4>
              <p>
                Complete lifecycle support — planning, filing, monitoring and
                representation.
              </p>
            </div>

            <div className="tp-benefit">
              <h4>Reduced legal & financial risk</h4>
              <p>
                Minimise penalties, interest and litigation through proactive
                compliance.
              </p>
            </div>

            <div className="tp-benefit">
              <h4>Expert audit handling</h4>
              <p>
                Experienced handling of assessments, audits & departmental
                interactions.
              </p>
            </div>

            <div className="tp-benefit">
              <h4>Optimized tax structure</h4>
              <p>
                Improve profitability and cash flow by aligning tax structure
                with business goals.
              </p>
            </div>

            <div className="tp-benefit">
              <h4>Data security & confidentiality</h4>
              <p>
                Controlled systems and secure handling of sensitive financial
                data.
              </p>
            </div>

            <div className="tp-benefit">
              <h4>Industry-specific expertise</h4>
              <p>
                Tailored solutions for different sectors and business sizes.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="tp-section tp-who">
        <div className="tp-container">
          <h3 className="tp-section-title"> Who We Serve</h3>

          <div className="tp-who-grid">
            <div className="tp-who-item">
              Individuals & salaried professionals
            </div>
            <div className="tp-who-item">SMEs, MSMEs & corporate entities</div>
            <div className="tp-who-item">
              Startups, LLPs, partnerships & family businesses
            </div>
            <div className="tp-who-item">
              NGOs, Trusts & Charitable Institutions
            </div>
            <div className="tp-who-item">
              NRI taxpayers & foreign companies operating in India
            </div>
          </div>
        </div>
      </section>

      <section className="tp-section tp-trust">
        <div className="tp-container tp-trust-inner">
          <div className="tp-trust-left">
            <h3 className="tp-section-title">
              {" "}
              Your Trusted Partner in Tax Compliance
            </h3>
            <p className="tp-text">
              We are committed to delivering accuracy, reliability and strategic
              value in every engagement. Our team stays updated on the latest
              tax laws, digital compliance platforms and regulatory
              announcements to ensure that our clients remain ahead of deadlines
              and protected from compliance risks.
            </p>
          </div>

          <div className="tp-trust-right">
            <p className="tp-text">
              Whether you need expert advisory, smooth return filings, GST or
              Income Tax management, or support during audits and appeals — we
              are here to guide you every step of the way.
            </p>
            <h4 className="tp-contact-title"> Get in Touch</h4>

            <Link
              to="/contactus"
              className="tp-cta-btn apply-btn"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              Reach Out for Consultation
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
